import { useMemo, useState } from "react";
import styles from "./ResetPasswordForm.module.scss";
import AuthentificationService from "../../../../httpService/AuthentificationService";
import { toast } from "react-toastify";
import { BounceLoader } from "react-spinners";
import CommonFormFieldWrapper from "../../../../common/components/form-field-wrapper/CommonFormFieldWrapper";
import { useForm } from "react-hook-form";

type Props = {
	setShowResetPassword: (value: boolean) => void;
};

type ResetPasswordFormProps = {
	email: string;
	password: string;
};

const ResetPasswordForm = (props: Props) => {
	const { setShowResetPassword } = props;
	const [loading, setLoading] = useState(false);
	const authService = useMemo(() => new AuthentificationService(), []);

	const {
		register,
		handleSubmit,
		formState: { isValid },
	} = useForm<ResetPasswordFormProps>({
		defaultValues: {
			email: "",
		},
		reValidateMode: "onSubmit",
		mode: "onTouched",
	});

	const onSubmit = async (data: ResetPasswordFormProps) => {
		if (!isValid) return;
		setLoading(true);

		try {
			await authService.post("/forgot-password", data);
			setLoading(false);
			toast.success("Password reset link sent to your email");
			setShowResetPassword(false);
		} catch (error: any) {
			const errorText: any = error.response?.data?.title;
			toast.error(errorText ?? "An unexpected error occurred");
			setLoading(false);
		}
	};

	return (
		<div className={styles.container}>
			<div className={styles.header}>
				<span className={styles.goBack} onClick={() => setShowResetPassword(false)}>
					<svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
						<mask id="mask0_971_30884" maskUnits="userSpaceOnUse" x="0" y="0" width="25" height="24">
							<rect width="24" height="24" transform="matrix(-1 0 0 1 24.5 0)" fill="#D9D9D9" />
						</mask>
						<g mask="url(#mask0_971_30884)">
							<path
								d="M11.5533 12.0005L15.6264 7.92737C15.7649 7.78892 15.8357 7.61489 15.8389 7.40527C15.8421 7.19568 15.7713 7.01844 15.6264 6.87357C15.4816 6.72869 15.3059 6.65625 15.0995 6.65625C14.8931 6.65625 14.7175 6.72869 14.5726 6.87357L10.0784 11.3678C9.9848 11.4614 9.91877 11.5601 9.88032 11.6639C9.84186 11.7678 9.82262 11.88 9.82262 12.0005C9.82262 12.121 9.84186 12.2332 9.88032 12.337C9.91877 12.4408 9.9848 12.5396 10.0784 12.6331L14.5726 17.1274C14.7111 17.2658 14.8851 17.3367 15.0947 17.3399C15.3043 17.3431 15.4816 17.2723 15.6264 17.1274C15.7713 16.9825 15.8438 16.8069 15.8438 16.6005C15.8438 16.3941 15.7713 16.2184 15.6264 16.0736L11.5533 12.0005Z"
								fill="#DE841B"
							/>
						</g>
					</svg>
				</span>
				Reset Password
			</div>
			<form onSubmit={handleSubmit(onSubmit)} className={styles.contentContainer}>
				<CommonFormFieldWrapper title="Email address">
					<input
						type="email"
						placeholder="Enter Email address"
						{...register("email", {
							required: "Email is required",
							pattern: {
								value: /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/,
								message: "Invalid email",
							},
						})}
					/>
				</CommonFormFieldWrapper>
				<button className={`standardButton ${styles.button} ${isValid ? "" : styles.disabledButton}`} type="submit">
					{loading ? (
						<BounceLoader color="#DE841B" size={25} />
					) : (
						<>
							Reset Password
							<svg width="7" height="12" viewBox="0 0 7 12" fill="none" xmlns="http://www.w3.org/2000/svg">
								<path
									d="M4.94665 6.00047L0.873576 1.92737C0.735109 1.78892 0.664276 1.61489 0.661076 1.40527C0.657859 1.19568 0.728692 1.01844 0.873576 0.873575C1.01844 0.728692 1.19408 0.65625 1.40048 0.65625C1.60688 0.65625 1.78251 0.728692 1.92738 0.873575L6.4216 5.3678C6.5152 5.46138 6.58123 5.5601 6.61968 5.66395C6.65814 5.76778 6.67738 5.87996 6.67738 6.00047C6.67738 6.12099 6.65814 6.23317 6.61968 6.337C6.58123 6.44085 6.5152 6.53957 6.4216 6.63315L1.92738 11.1274C1.78893 11.2658 1.61489 11.3367 1.40527 11.3399C1.19568 11.3431 1.01844 11.2723 0.873576 11.1274C0.728692 10.9825 0.65625 10.8069 0.65625 10.6005C0.65625 10.3941 0.728692 10.2184 0.873576 10.0736L4.94665 6.00047Z"
									fill="#F68B1E"
								/>
							</svg>
						</>
					)}
				</button>
				<div className={`link`}>Need Help?</div>
			</form>
		</div>
	);
};

export default ResetPasswordForm;
